<template>
    <div>
        <div
            :class="[
                hasError(errors, 'shipping_address_id')
                    ? 'border-red-600'
                    : 'border-gray-200',
                'overflow-hidden bg-white shadow rounded-lg border',
            ]"
        >
            <div
                :class="[
                    hasError(errors, 'shipping_address_id')
                        ? 'bg-red-500 text-white border-red-600'
                        : 'bg-gray-100 text-gray-800 border-gray-200',
                    'flex items-center px-4 py-5 sm:px-6 border-b',
                ]"
            >
                <TruckIcon class="h-5 w-5 mr-2" aria-hidden="true" />
                <h2 class="font-bold">Shipping Address</h2>
            </div>

            <div class="px-4 py-3 sm:px-6">
                <div>
                    <div class="py-3 flex text-gray-700">
                        <UserIcon
                            class="h-5 w-5 mr-2 shrink-0"
                            aria-hidden="true"
                        />

                        <div>
                            <p>
                                {{ address.name }}
                            </p>
                        </div>
                    </div>

                    <div class="py-3 flex text-gray-700">
                        <LocationMarkerIcon
                            class="h-5 w-5 mr-2 shrink-0"
                            aria-hidden="true"
                        />

                        <div>
                            <p>
                                {{ address.line1 }}
                                <span v-if="address.line2">
                                    <br />
                                    {{ address.line2 }}
                                </span>
                            </p>

                            <p>
                                <span v-if="address.state">
                                    {{ address.city }}, {{ address.state }}
                                    {{ address.postal_code }}
                                </span>

                                <span v-else>
                                    {{ address.city }} {{ address.postal_code }}
                                </span>
                            </p>

                            <p>
                                {{ address.country.name }}
                            </p>
                        </div>
                    </div>

                    <div class="py-3 flex text-gray-700">
                        <MailIcon class="h-5 w-5 mr-2 shrink-0" />

                        <div class="break-all">
                            <p>
                                {{ address.email ? address.email : "(none)" }}
                            </p>
                        </div>
                    </div>

                    <div class="py-3 flex text-gray-700">
                        <PhoneIcon class="h-5 w-5 mr-2 shrink-0" />

                        <div>
                            <p>
                                {{ address.phone ? address.phone : "(none)" }}
                            </p>
                        </div>
                    </div>
                </div>

                <ChangeUserCheckoutShippingAddressButton
                    :addresses="addresses"
                    :countries="countries"
                    :csrf="csrf"
                    :emailOptIn="emailOptIn"
                    :errors="errors"
                    :includeVerifyField="includeVerifyField"
                    :initialAddress="address"
                    :initialCountry="country"
                    :initialStates="states"
                    :old="old"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {
    LocationMarkerIcon,
    MailIcon,
    PhoneIcon,
    TruckIcon,
    UserIcon,
} from "@heroicons/vue/solid";
import { useForm } from "../../functions/useForm";
import ChangeUserCheckoutShippingAddressButton from "./ChangeUserCheckoutShippingAddressButton.vue";
import { rememberAbandonedCart } from "../../api/cart";

const props = withDefaults(
    defineProps<{
        address?: any;
        addresses?: any;
        amount?: number;
        countries?: any;
        country?: any;
        csrf?: string;
        emailOptIn?: string;
        errors?: any;
        includeVerifyField?: boolean;
        initialCountry?: any;
        old?: any;
        states?: any;
    }>(),
    {
        emailOptIn: "1",
        includeVerifyField: false,
    },
);

const { hasError } = useForm();

if (props.address.email) {
    rememberAbandonedCart({
        name: props.address.name,
        email: props.address.email,
    });
}
</script>
